import Modal from './Modal';

export function AdminSecretModal({ open, email, setEmail, password, setPassword, error, loading, onSubmit, onCancel }) {
  return (
    <Modal open={open} onClose={onCancel}>
      <h3 style={{ marginBottom: '1rem', fontFamily: 'Syne' }}>Admin Access</h3>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <input
            type="email"
            className="form-input"
            placeholder="Admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            required
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            className="form-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p style={{ color: '#e05252', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</p>}
        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Checking…' : 'Enter'}
          </button>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>Cancel</button>
        </div>
      </form>
    </Modal>
  );
}

export function AdminToggle({ adminMode, onToggle }) {
  return (
    <label className="admin-toggle">
      <input
        type="checkbox"
        className="admin-switch"
        checked={adminMode}
        onChange={(e) => onToggle(e.target.checked)}
      />
      Admin
    </label>
  );
}
